import Colors from '../../../../shared/assets/style/default/color';
import Props from '../../../../shared/types/props/button';
import Screen from '../../../../shared/utils/screen';

function ChannelsIcon({ focused, width, height, margin }: Props) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width ? width * Screen.widthRatio : `${32 * Screen.widthRatio}`}
      height={height ? height * Screen.widthRatio : `${30 * Screen.widthRatio}`}
      viewBox={'0 0 32 30'}
      style={{ margin: margin ? margin : 0 }}
    >
      <path
        fill={focused ? Colors['dark'] : Colors['light']}
        fillRule='evenodd'
        d='M9.943 8.234h23V0h-23zm0 9.883h23V9.883h-23zm0 9.883h23v-8.234h-23zM0 8.234h8V0H0zm0 9.883h8V9.883H0zM0 28h8v-8.234H0z'
      ></path>
      <path
        fill={focused ? Colors['dark'] : Colors['light']}
        fillRule='evenodd'
        d='M10.1055 25.9272C10.1055 24.9726 10.8793 24.1987 11.834 24.1987H30.2711C31.2257 24.1987 31.9996 24.9726 31.9996 25.9272V27.6557C31.9996 28.6103 31.2257 29.3842 30.2711 29.3842H11.834C10.8793 29.3842 10.1055 28.6103 10.1055 27.6557V25.9272Z'
      />
      <path
        fill={focused ? Colors['dark'] : Colors['light']}
        fillRule='evenodd'
        d='M10.1055 13.8278C10.1055 12.8732 10.8793 12.0994 11.834 12.0994H30.2711C31.2257 12.0994 31.9996 12.8732 31.9996 13.8278V15.5563C31.9996 16.5109 31.2257 17.2848 30.2711 17.2848H11.834C10.8793 17.2848 10.1055 16.5109 10.1055 15.5563V13.8278Z'
      />
      <path
        fill={focused ? Colors['dark'] : Colors['light']}
        fillRule='evenodd'
        d='M10.1055 1.72848C10.1055 0.773869 10.8793 0 11.834 0H30.2711C31.2257 0 31.9996 0.773869 31.9996 1.72848V3.45697C31.9996 4.41158 31.2257 5.18545 30.2711 5.18545H11.834C10.8793 5.18545 10.1055 4.41158 10.1055 3.45697V1.72848Z'
      />
      <path
        fill={focused ? Colors['dark'] : Colors['light']}
        fillRule='evenodd'
        d='M0 2.02231C0 1.06769 0.773869 0.293823 1.72848 0.293823H5.32373C6.27835 0.293823 7.05221 1.06769 7.05221 2.02231V3.26682C7.05221 4.22143 6.27835 4.9953 5.32373 4.9953H1.72848C0.773869 4.9953 0 4.22143 0 3.26682V2.02231Z'
      />
      <path
        fill={focused ? Colors['dark'] : Colors['light']}
        fillRule='evenodd'
        d='M0 13.776C0 12.8214 0.773869 12.0475 1.72848 12.0475H5.32373C6.27835 12.0475 7.05221 12.8214 7.05221 13.776V15.6082C7.05221 16.5628 6.27835 17.3366 5.32373 17.3366H1.72848C0.773869 17.3366 0 16.5628 0 15.6082V13.776Z'
      />
      <path
        fill={focused ? Colors['dark'] : Colors['light']}
        fillRule='evenodd'
        d='M0 26.1174C0 25.1628 0.773869 24.3889 1.72848 24.3889H5.32373C6.27835 24.3889 7.05221 25.1628 7.05221 26.1174V27.3619C7.05221 28.3165 6.27835 29.0904 5.32373 29.0904H1.72848C0.773869 29.0904 0 28.3165 0 27.3619V26.1174Z'
      />
    </svg>
  );
}

export default ChannelsIcon;
